var cardElement;
var paymentProcessingText = 'Processing...';
var submitButtonText = document.getElementById('register-form__submit') ? document.getElementById('register-form__submit').value : 'Submit';
var stripe = typeof Stripe === 'function' ? Stripe(window.paymentPublishableKey) : null;
var planInfo = document.getElementById('subscription-info') ? document.getElementById('subscription-info').getAttribute('data-subscription-info') : null;
var country = document.getElementById('country') ? document.getElementById('country').value.toUpperCase() : 'US';
var currency = document.getElementById('currency') ? document.getElementById('currency').value : 'usd';

var applePayRequest = stripe.paymentRequest({
	country,
	currency,
	total: {
		label: 'Glo',
		amount: 3000
	},
	displayItems: [{
		label: 'Recurring monthly subscription fee, billed after trial period.',
		amount: 3000
	}]
});

if (planInfo && planInfo.length) planInfo = JSON.parse(planInfo);

// Remove sensitive data from DOM
if (document.getElementById('subscription-info')) document.getElementById('subscription-info').remove();

function loadSubscriptionPlans(subscriptionPlans) {
	var subscriptionWrapperEls = document.querySelectorAll('.subscription-plans__wrapper');
	const isPayrollVariation = !!document.querySelector('[id=is-payroll-variation]');
	const referral = document.getElementById('was-referred').value == 'true';

	subscriptionWrapperEls.forEach(function(subscriptionWrapperEl) {
		var formType = subscriptionWrapperEl.getAttribute('data-form-type');
		var subscriptionGroupIdEl = document.getElementById(`subscription-group-id-${formType}`);
		var subscriptionPlansTemplate = require('../../../server/views/partials/templates/subscription-plans.html');
		var userPlanIdEl = document.getElementById(`user-plan-id-${formType}`);

		if (!subscriptionPlans) {
			var subscriptionPlansEl = document.getElementById(`subscription-plans-data-${formType}`);

			subscriptionPlans = subscriptionPlansEl.value ? JSON.parse(subscriptionPlansEl.value) : null;
			subscriptionGroupIdEl.remove();
			subscriptionPlansEl.remove();
			userPlanIdEl.remove();
		}

		if (!subscriptionPlans) return;

		document.getElementById(`subscription-plans-${formType}`).innerHTML = subscriptionPlansTemplate({
			formType,
			subscriptionGroupId: subscriptionGroupIdEl ? subscriptionGroupIdEl.value : null,
			subscriptionPlans,
			userPlanId: userPlanIdEl ? userPlanIdEl.value : userPlanIdEl,
			isPayrollVariation,
			referral
		});
	});

	if (document.querySelector('.owl-item.active')) {
		var updatedCardHeight = document.querySelector('.owl-item.active').getBoundingClientRect().height + 'px';
		document.querySelector('.owl-stage-outer').style.height = updatedCardHeight;
	}
}

function processPayment() {
	return stripe.createToken(cardElement).then(function(result) {
		if (result.error) {
			// Inform the user if there was an error
			document.getElementById('register-form__card').setAttribute('data-error', result.error.message);
			return;
		} else {
			// Send the token to your server
			return result.token.id;
		}
	});
}

/**************
 * Form Setup *
 **************/

function initPayment() {
	var isDarkMode = !!document.querySelector('.body--relax');
	var inputColor = isDarkMode ? '#fff' : '#1e1e28';
	var elements = stripe.elements({
		fonts: [{
			family: 'Graphik Web',
			src: `url(${CDN_BASE_WEB_ASSETS}/fonts/graphik/Graphik-Regular-Web.woff)`
		}]
	});

	cardElement = elements.create('card', {
		hidePostalCode: window.location.pathname !== '/gift'
			&& window.location.pathname !== '/account'
			&& !window.location.pathname.includes('/promo'),
		style: {
			base: {
				color: inputColor,
				iconColor: inputColor,
				fontSize: '16px',
				fontFamily: 'Graphik Web',
				fontSmoothing: 'antialiased',
				'::placeholder': {
					color: inputColor,
				},
				'::disabled': {
					color: '#a1a6ac',
				},
			},
			invalid: {
				color: '#e86046',
				iconColor: '#e86046',
			}
		}
	});

	cardElement.mount('#register-form__card');

	cardElement.on('change', function(event) {
		var errorContainer = document.getElementById('register-form__card');

		if (event.error) {
			errorContainer.setAttribute('data-error', event.error.message);
		} else if (!event.empty) {
			errorContainer.setAttribute('data-error', '');
		}
	});

	cardElement.on('ready', function() {
		cardElement.focus && cardElement.focus();
	});
}

export {
	applePayRequest,
	cardElement,
	initPayment,
	loadSubscriptionPlans,
	paymentProcessingText,
	planInfo,
	processPayment,
	stripe,
	submitButtonText
};
